var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { checkIsPlatform, DateTimePicker, Input, isValidObject } from '@airtel/air-design-system';
import { forwardRef, useEffect, useState } from 'react';
import { CheckboxGroupWidget } from '../../../checkbox-group-widget';
import { DropdownWidget } from '../../../dropdown-widget';
import { RadioGroupWidget } from '../../../radio-group-widget';
import { clearTimeoutMethod } from '../../FormWidgetUtils';
export var SingleFormField = forwardRef((props, ref) => {
  var _a, _b, _c, _d, _e;
  var fieldType = props.fieldType,
    fieldId = props.fieldId,
    _props$fieldData = props.fieldData,
    fieldData = _props$fieldData === void 0 ? {} : _props$fieldData,
    updateFormField = props.updateFormField,
    onUserAction = props.onUserAction,
    setZindex = props.setZindex,
    zIndexValue = props.zIndexValue,
    _props$shouldTrimText = props.shouldTrimText,
    shouldTrimText = _props$shouldTrimText === void 0 ? true : _props$shouldTrimText,
    _props$enableValidInp = props.enableValidInputDebounce,
    enableValidInputDebounce = _props$enableValidInp === void 0 ? false : _props$enableValidInp,
    _props$onValidInputDe = props.onValidInputDelay,
    onValidInputDelay = _props$onValidInputDe === void 0 ? 800 : _props$onValidInputDe,
    focusNextOnValidInput = props.focusNextOnValidInput,
    _props$trimFieldValue = props.trimFieldValue,
    trimFieldValue = _props$trimFieldValue === void 0 ? true : _props$trimFieldValue,
    restProps = __rest(props, ["fieldType", "fieldId", "fieldData", "updateFormField", "onUserAction", "setZindex", "zIndexValue", "shouldTrimText", "enableValidInputDebounce", "onValidInputDelay", "focusNextOnValidInput", "trimFieldValue"]);
  var checkedRadioId = (fieldData === null || fieldData === void 0 ? void 0 : fieldData.checkedRadioId) || ((_b = (_a = fieldData === null || fieldData === void 0 ? void 0 : fieldData.radioButtons) === null || _a === void 0 ? void 0 : _a.find(item => item === null || item === void 0 ? void 0 : item.checked)) === null || _b === void 0 ? void 0 : _b.id);
  var selectedDropdownValue = (_c = fieldData === null || fieldData === void 0 ? void 0 : fieldData.value) !== null && _c !== void 0 ? _c : '';
  var _useState = useState(fieldData),
    fieldDataState = _useState[0],
    setFieldDataState = _useState[1];
  var _useState2 = useState(''),
    localCheckedRadioId = _useState2[0],
    setLocalCheckedRadioId = _useState2[1];
  var _useState3 = useState(selectedDropdownValue),
    localSelectedDropdownValue = _useState3[0],
    setLocalSelectedDropdownValue = _useState3[1];
  useEffect(() => {
    setFieldDataState(fieldData);
  }, [JSON.stringify(fieldData)]);
  useEffect(() => {
    if (fieldType === 'RADIO' && localCheckedRadioId !== checkedRadioId) {
      setLocalCheckedRadioId(checkedRadioId);
      updateFormField(fieldId, checkedRadioId);
    }
  }, [checkedRadioId]);
  useEffect(() => {
    if (fieldType === 'DROPDOWN' && localSelectedDropdownValue !== selectedDropdownValue) {
      setLocalSelectedDropdownValue(selectedDropdownValue);
      updateFormField(fieldId, [selectedDropdownValue], true, selectedDropdownValue === '');
    }
  }, [selectedDropdownValue]);
  useEffect(() => {
    var timeoutId;
    if (!checkIsPlatform('web') && (fieldData === null || fieldData === void 0 ? void 0 : fieldData.updateFromNativeBridge)) {
      timeoutId = setTimeout(() => {
        var _a, _b;
        onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({}, (_a = fieldData === null || fieldData === void 0 ? void 0 : fieldData.nativeBridgePayload) === null || _a === void 0 ? void 0 : _a.metaData), Object.assign(Object.assign({
          fieldType
        }, fieldData), (_b = fieldData === null || fieldData === void 0 ? void 0 : fieldData.nativeBridgePayload) === null || _b === void 0 ? void 0 : _b.extraData), value => {
          updateFormField(fieldId, "" + (value !== null && value !== void 0 ? value : ''));
        });
      }, 10);
    }
    return () => timeoutId && clearTimeout(timeoutId);
  }, []);
  if (!fieldDataState) return null;
  var _inputFieldDataState = fieldDataState || {};
  var _dateTimeState = fieldDataState;
  var inputContainerDropdown = Object.assign({}, fieldDataState === null || fieldDataState === void 0 ? void 0 : fieldDataState.inputContainerProps);
  var onTextChange = value => {
    if (_inputFieldDataState.state === 'error') {
      setFieldDataState(Object.assign(Object.assign({}, fieldDataState), {
        state: 'none',
        hintText: ''
      }));
    }
    onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id: fieldData === null || fieldData === void 0 ? void 0 : fieldData.id
    }, _inputFieldDataState === null || _inputFieldDataState === void 0 ? void 0 : _inputFieldDataState.onChangeText), Object.assign(Object.assign({
      fieldType
    }, fieldData), {
      value: trimFieldValue ? value === null || value === void 0 ? void 0 : value.trim() : value
    }));
    updateFormField(fieldId, value, shouldTrimText);
  };
  var onValidInput = value => {
    (fieldData === null || fieldData === void 0 ? void 0 : fieldData.nextFocusId) && focusNextOnValidInput(fieldData === null || fieldData === void 0 ? void 0 : fieldData.nextFocusId, fieldId, enableValidInputDebounce, onValidInputDelay);
    onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id: fieldData === null || fieldData === void 0 ? void 0 : fieldData.id
    }, _inputFieldDataState === null || _inputFieldDataState === void 0 ? void 0 : _inputFieldDataState.onValidInput), Object.assign(Object.assign({
      fieldType
    }, fieldData), {
      value: trimFieldValue ? value === null || value === void 0 ? void 0 : value.trim() : value
    }));
  };
  var onChangeDateTimePicker = date => {
    if (isValidObject(_dateTimeState === null || _dateTimeState === void 0 ? void 0 : _dateTimeState.onChangeMetaData)) {
      onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id: fieldData === null || fieldData === void 0 ? void 0 : fieldData.id
      }, _dateTimeState === null || _dateTimeState === void 0 ? void 0 : _dateTimeState.onChangeMetaData), Object.assign(Object.assign({
        fieldType
      }, fieldData), {
        date
      }));
      updateFormField(fieldId, date);
    }
  };
  var onInvalidDateTimePicker = date => {
    if (isValidObject(_dateTimeState === null || _dateTimeState === void 0 ? void 0 : _dateTimeState.onInvalidMetaData)) {
      onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id: fieldData === null || fieldData === void 0 ? void 0 : fieldData.id
      }, _dateTimeState === null || _dateTimeState === void 0 ? void 0 : _dateTimeState.onInvalidMetaData), Object.assign(Object.assign({
        fieldType
      }, fieldData), {
        date
      }));
    }
  };
  var onDateTimePickerOpen = () => {
    setZindex === null || setZindex === void 0 ? void 0 : setZindex(zIndexValue);
    if (isValidObject(_dateTimeState === null || _dateTimeState === void 0 ? void 0 : _dateTimeState.onOpenMetaData)) {
      onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id: fieldData === null || fieldData === void 0 ? void 0 : fieldData.id
      }, _dateTimeState === null || _dateTimeState === void 0 ? void 0 : _dateTimeState.onOpenMetaData), Object.assign({
        fieldType
      }, fieldData));
    }
  };
  var onDateTimePickerClose = () => {
    setZindex === null || setZindex === void 0 ? void 0 : setZindex(-1);
    if (isValidObject(_dateTimeState === null || _dateTimeState === void 0 ? void 0 : _dateTimeState.onCloseMetaData)) {
      onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id: fieldData === null || fieldData === void 0 ? void 0 : fieldData.id
      }, _dateTimeState === null || _dateTimeState === void 0 ? void 0 : _dateTimeState.onCloseMetaData), Object.assign({
        fieldType
      }, fieldData));
    }
  };
  var onInValidInput = value => {
    onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id: fieldData === null || fieldData === void 0 ? void 0 : fieldData.id
    }, _inputFieldDataState === null || _inputFieldDataState === void 0 ? void 0 : _inputFieldDataState.onInValidInput), Object.assign(Object.assign({}, fieldData), {
      value: trimFieldValue ? value === null || value === void 0 ? void 0 : value.trim() : value,
      fieldType
    }));
  };
  var actionCtaWithOnPressProps = (fieldDataState === null || fieldDataState === void 0 ? void 0 : fieldDataState.actionCta) && Object.assign(Object.assign({}, _inputFieldDataState === null || _inputFieldDataState === void 0 ? void 0 : _inputFieldDataState.actionCta), {
    onPress: () => {
      var _a, _b;
      return !!((_a = _inputFieldDataState === null || _inputFieldDataState === void 0 ? void 0 : _inputFieldDataState.actionCta) === null || _a === void 0 ? void 0 : _a.onPress) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id: fieldData === null || fieldData === void 0 ? void 0 : fieldData.id
      }, _inputFieldDataState === null || _inputFieldDataState === void 0 ? void 0 : _inputFieldDataState.actionCta.onPress), Object.assign(Object.assign({
        fieldType
      }, fieldData), {
        value: (_b = fieldData === null || fieldData === void 0 ? void 0 : fieldData.value) === null || _b === void 0 ? void 0 : _b.trim()
      })));
    }
  });
  var appendItemWithOnPressProps = Object.assign(Object.assign({}, _inputFieldDataState === null || _inputFieldDataState === void 0 ? void 0 : _inputFieldDataState.appendItems), {
    onPress: () => {
      var _a, _b;
      return !!((_a = _inputFieldDataState === null || _inputFieldDataState === void 0 ? void 0 : _inputFieldDataState.appendItems) === null || _a === void 0 ? void 0 : _a.onPress) && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id: fieldData === null || fieldData === void 0 ? void 0 : fieldData.id
      }, _inputFieldDataState.appendItems.onPress), Object.assign(Object.assign({
        fieldType
      }, fieldData), {
        value: (_b = fieldData === null || fieldData === void 0 ? void 0 : fieldData.value) === null || _b === void 0 ? void 0 : _b.trim()
      })));
    }
  });
  var onRadioItemPress = data => {
    var _radioFieldDataState = fieldDataState;
    var dataObject = null;
    var onSelection = _radioFieldDataState === null || _radioFieldDataState === void 0 ? void 0 : _radioFieldDataState.onSelection;
    if (data === null || data === void 0 ? void 0 : data.onPress) {
      dataObject = data.onPress;
    } else if (onSelection && Object.keys(onSelection).length > 0) {
      dataObject = onSelection;
    }
    if (dataObject) {
      onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id: fieldData === null || fieldData === void 0 ? void 0 : fieldData.id
      }, dataObject), Object.assign(Object.assign({
        fieldType
      }, fieldData), {
        data,
        fieldId
      }));
    }
    setLocalCheckedRadioId(data === null || data === void 0 ? void 0 : data.id);
    updateFormField(fieldId, data === null || data === void 0 ? void 0 : data.id);
  };
  var onSelectDropdownValue = (_a, _b) => {
    var _c;
    var id = _a.id,
      onSelectMetaData = __rest(_a, ["id"]);
    var _d = _b === void 0 ? {} : _b,
      _e = _d.data,
      data = _e === void 0 ? [] : _e,
      searchedTerm = _d.searchedTerm;
    if (data) {
      onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
        id
      }, onSelectMetaData), {
        data,
        searchedTerm
      });
    }
    if ((data === null || data === void 0 ? void 0 : data.length) > 0) {
      var firstValue = (_c = data[0]) === null || _c === void 0 ? void 0 : _c.value;
      setLocalSelectedDropdownValue(firstValue);
    }
    var dataIdArray = (data === null || data === void 0 ? void 0 : data.length) > 0 && (data === null || data === void 0 ? void 0 : data.map(list => {
      var _a;
      return (_a = list === null || list === void 0 ? void 0 : list.heading) !== null && _a !== void 0 ? _a : list === null || list === void 0 ? void 0 : list.value;
    }));
    updateFormField(fieldId, dataIdArray !== null && dataIdArray !== void 0 ? dataIdArray : []);
  };
  var onSelectCheckboxValue = (_a, _b) => {
    var _c;
    var id = _a.id,
      onSelectionMeta = __rest(_a, ["id"]);
    var checkedState = _b.checkedState;
    onSelectionMeta && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id
    }, onSelectionMeta), {
      checkedState
    }));
    var dataArray = (_c = Object.keys(checkedState)) === null || _c === void 0 ? void 0 : _c.filter(key => checkedState[key]);
    updateFormField(fieldId, dataArray !== null && dataArray !== void 0 ? dataArray : []);
  };
  var onClearButtonPress = () => {
    onTextChange('');
    onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id: fieldData === null || fieldData === void 0 ? void 0 : fieldData.id
    }, _inputFieldDataState === null || _inputFieldDataState === void 0 ? void 0 : _inputFieldDataState.onClearButtonPress), Object.assign({
      fieldType
    }, fieldData));
  };
  var readOnlyOnPressHandler = () => {
    onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id: fieldData === null || fieldData === void 0 ? void 0 : fieldData.id
    }, _inputFieldDataState === null || _inputFieldDataState === void 0 ? void 0 : _inputFieldDataState.readOnlyOnPress), Object.assign({
      fieldType
    }, fieldData));
  };
  var onBlur = event => {
    var _a;
    var value = (_a = event === null || event === void 0 ? void 0 : event.nativeEvent) === null || _a === void 0 ? void 0 : _a.text;
    onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id: fieldData.id
    }, fieldData.onBlur), Object.assign(Object.assign({
      fieldType
    }, fieldData), {
      value: trimFieldValue ? value === null || value === void 0 ? void 0 : value.trim() : value
    }));
  };
  var onFocus = event => {
    var _a;
    var value = (_a = event === null || event === void 0 ? void 0 : event.nativeEvent) === null || _a === void 0 ? void 0 : _a.text;
    onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id: fieldData.id
    }, fieldData.onFocus), Object.assign(Object.assign({
      fieldType
    }, fieldData), {
      value: trimFieldValue ? value === null || value === void 0 ? void 0 : value.trim() : value
    }));
  };
  var onPressInHandler = () => {
    var _a;
    clearTimeoutMethod();
    fieldData.onPressIn && (onUserAction === null || onUserAction === void 0 ? void 0 : onUserAction(Object.assign({
      id: fieldData.id
    }, fieldData.onPressIn), Object.assign(Object.assign({
      fieldType
    }, fieldData), {
      value: (_a = fieldData === null || fieldData === void 0 ? void 0 : fieldData.value) === null || _a === void 0 ? void 0 : _a.trim()
    })));
  };
  return _jsxs(_Fragment, {
    children: [fieldType === 'RADIO' && _jsx(RadioGroupWidget, Object.assign({
      ref: ref
    }, fieldDataState, {
      checkedRadioId: localCheckedRadioId
    }, restProps, {
      onSelectionHandler: onRadioItemPress
    })), fieldType === 'CHECKBOX' && _jsx(CheckboxGroupWidget, Object.assign({
      ref: ref
    }, fieldDataState, restProps, {
      onUserAction: onSelectCheckboxValue
    })), fieldType === 'DROPDOWN' && _jsx(DropdownWidget, Object.assign({
      ref: ref
    }, fieldDataState, restProps, {
      inputContainerProps: inputContainerDropdown,
      variant: (_d = fieldDataState === null || fieldDataState === void 0 ? void 0 : fieldDataState.variant) !== null && _d !== void 0 ? _d : 'none',
      onUserAction: onSelectDropdownValue
    })), fieldType === 'INPUT' && _jsx(Input, Object.assign({
      ref: ref
    }, fieldDataState, restProps, {
      actionCta: actionCtaWithOnPressProps,
      appendItems: appendItemWithOnPressProps,
      onChangeText: onTextChange,
      onValidInput: onValidInput,
      onInValidInput: onInValidInput,
      onBlur: onBlur,
      onFocus: onFocus,
      onClearButtonPress: onClearButtonPress,
      readOnlyOnPress: readOnlyOnPressHandler,
      onHintActionPressHandler: () => {
        var _a;
        var onHintActionPress = restProps.onHintActionPress || fieldData.onHintActionPress;
        onHintActionPress && onUserAction(Object.assign({
          id: fieldData.id
        }, onHintActionPress), Object.assign(Object.assign(Object.assign({
          fieldType
        }, fieldDataState), {
          value: (_a = fieldDataState === null || fieldDataState === void 0 ? void 0 : fieldDataState.value) === null || _a === void 0 ? void 0 : _a.trim()
        }), restProps));
      }
    }, checkIsPlatform('web') ? {
      onClick: onPressInHandler
    } : {
      onPressIn: onPressInHandler
    })), fieldType === 'DATE' && _jsx(DateTimePicker, Object.assign({
      ref: ref
    }, fieldDataState, {
      variant: (_e = fieldDataState === null || fieldDataState === void 0 ? void 0 : fieldDataState.variant) !== null && _e !== void 0 ? _e : 'input',
      onChange: onChangeDateTimePicker,
      onOpen: onDateTimePickerOpen,
      onClose: onDateTimePickerClose,
      onInValidInput: onInvalidDateTimePicker
    }))]
  });
});